import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-nav-menu',
  templateUrl: './report-nav-menu.component.html',
  styleUrls: ['./report-nav-menu.component.css']
})
export class ReportNavMenuComponent implements OnInit {

  @Input() week = '';
  @Input() year = '';
  @Input() currentReport = '';

  constructor() { }

  ngOnInit(): void {
  }

}
